module.exports = __webpack_public_path__ + "static/media/canecas.f5f18f66.jpg";